import { render, staticRenderFns } from "./HelpLGPD.vue?vue&type=template&id=12720aab&"
import script from "./HelpLGPD.vue?vue&type=script&lang=js&"
export * from "./HelpLGPD.vue?vue&type=script&lang=js&"
import style0 from "./HelpLGPD.vue?vue&type=style&index=0&id=12720aab&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports